import React from 'react';
import Crop from '@src/components/Crop';
import { useSelector } from 'react-redux';
import {
	specItems,
	activeSpecDetails,
} from '@src/containers/ProfileVenue/selectors';
import { useActions } from '@src/containers/ProfileVenue/hooks';
import FitEvents from './common';

const FitEventsConnector = () => {
	const events = useSelector(specItems);
	const activeEvent = useSelector(activeSpecDetails);
	const { updateUserInput } = useActions();

	if (events.length === 0) {
		events.push({ id: -1, isActive: true, name: t('Все мероприятия') });
	}

	return (
		<FitEvents events={events} onChangeValue={updateUserInput}>
			{activeEvent && activeEvent.content && (
				<Crop value={t('Развернуть')} maxHeight={100}>
					{activeEvent.content}
				</Crop>
			)}
		</FitEvents>
	);
};

export default FitEventsConnector;
